<div class="main-content table-page table-page--compact table-page--dense autorizaciones-page">
  <div class="container-fluid">
  <section class="table-page__hero">
    <div class="table-page__copy">
      <h1>Autorizaciones de tiempo</h1>
      <p>Resuelve los excesos diarios pendientes y consulta el historial de solicitudes enviadas.</p>
    </div>
  </section>

  <section class="autorizaciones-page__stats">
    <article class="autorizaciones-page__stat-card">
      <span class="autorizaciones-page__stat-label">Pendientes por resolver</span>
      <strong>{{ pendientesTotal }}</strong>
      <small>Solicitudes del equipo que requieren decisión</small>
    </article>
    <article class="autorizaciones-page__stat-card">
      <span class="autorizaciones-page__stat-label">Pendientes propias</span>
      <strong>{{ pendientesPropiasTotal }}</strong>
      <small>Tiempo extra enviado y aún no resuelto</small>
    </article>
    <article class="autorizaciones-page__stat-card">
      <span class="autorizaciones-page__stat-label">Aprobadas</span>
      <strong>{{ aprobadasTotal }}</strong>
      <small>Solicitudes regularizadas por tu líder</small>
    </article>
    <article class="autorizaciones-page__stat-card">
      <span class="autorizaciones-page__stat-label">Rechazadas</span>
      <strong>{{ rechazadasTotal }}</strong>
      <small>Solicitudes que requieren ajuste o aclaración</small>
    </article>
  </section>

  <section class="table-page__card">
    <div class="table-page__toolbar">
      <h2 class="autorizaciones-page__titulo">Pendientes del líder</h2>
    </div>

    <div class="table-page__table-wrap" *ngIf="pendientesLider.length; else emptyPendientes">
      <table class="table-page__table">
        <thead>
          <tr>
            <th>Colaborador</th>
            <th>Fecha</th>
            <th>Contexto</th>
            <th>Exceso</th>
            <th>Motivo</th>
            <th class="table-page__actions-head table-page__actions--multi">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="
              let solicitud of pendientesLider
                | paginate
                  : {
                      id: 'pendientesLider',
                      itemsPerPage: pageSize,
                      currentPage: currentPagePendientes,
                      totalItems: pendientesLider.length
                    }
            "
          >
            <td>
              <div class="table-page__cell-stack">
                <span class="table-page__name">{{ solicitud.nombreUsuario || "Sin colaborador" }}</span>
                <span class="table-page__subtext">{{ solicitud.nombreLider || "Sin líder" }}</span>
              </div>
            </td>
            <td>
              <div class="table-page__cell-stack">
                <span class="table-page__text">{{ solicitud.fechaTrabajo | date : "dd/MM/yyyy" }}</span>
                <span class="table-page__subtext">{{ solicitud.fechaSolicitud | date : "dd/MM/yyyy HH:mm" }}</span>
              </div>
            </td>
            <td>
              <div class="table-page__cell-stack">
                <span class="table-page__text">{{ solicitud.nombreProyecto || "Proyecto no identificado" }}</span>
                <span class="table-page__subtext">{{ solicitud.nombreTarea || "Sin tarea ligada" }}</span>
              </div>
            </td>
            <td>
              <div class="table-page__cell-stack">
                <span class="table-page__text">{{ solicitud.minutosSolicitados }} min</span>
                <span class="table-page__subtext">{{ solicitud.origenRegistro || "TIMER" }}</span>
              </div>
            </td>
            <td>
              <span class="autorizaciones-page__reason">{{ solicitud.motivoEmpleado }}</span>
            </td>
            <td class="table-page__actions table-page__actions--multi">
              <div class="table-page__action-group">
                <button
                  type="button"
                  class="table-page__action-btn"
                  title="Aprobar"
                  aria-label="Aprobar"
                  (click)="resolverSolicitud(solicitud, 'APROBADO')"
                >
                  <span class="material-icons">check_circle</span>
                </button>
                <button
                  type="button"
                  class="table-page__action-btn table-page__action-btn--danger"
                  title="Rechazar"
                  aria-label="Rechazar"
                  (click)="resolverSolicitud(solicitud, 'RECHAZADO')"
                >
                  <span class="material-icons">cancel</span>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="table-page__footer" *ngIf="showPendientesPagination">
      <div class="table-page__meta">
        Mostrando {{ (currentPagePendientes - 1) * pageSize + 1 }} a
        {{ currentPagePendientes * pageSize > pendientesLider.length ? pendientesLider.length : currentPagePendientes * pageSize }}
        de {{ pendientesLider.length }}
      </div>
      <div class="table-page__pager table-page__pager--ngx">
        <pagination-controls
          [id]="'pendientesLider'"
          responsive="true"
          class="my-pagination"
          previousLabel="Anterior"
          nextLabel="Siguiente"
          [directionLinks]="true"
          [autoHide]="false"
          [maxSize]="5"
          (pageChange)="currentPagePendientes = $event"
        ></pagination-controls>
      </div>
    </div>
  </section>

  <section class="table-page__card">
    <div class="table-page__toolbar table-page__toolbar--filters">
      <h2 class="autorizaciones-page__titulo">Mis solicitudes</h2>
      <div class="table-page__filters-grid autorizaciones-page__filtros">
        <div class="table-page__filter table-page__filter--medium">
          <mat-form-field appearance="outline" class="table-page__field">
            <mat-label>Estatus</mat-label>
            <mat-select [(ngModel)]="filtroMisSolicitudes" (selectionChange)="onFiltroMisSolicitudesChange()">
              <mat-option value="TODOS">Todos</mat-option>
              <mat-option value="PENDIENTE">Pendiente</mat-option>
              <mat-option value="APROBADO">Aprobado</mat-option>
              <mat-option value="RECHAZADO">Rechazado</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="table-page__table-wrap" *ngIf="solicitudesUsuario.length; else emptySolicitudes">
      <table class="table-page__table">
        <thead>
          <tr>
            <th>Fecha</th>
            <th>Contexto</th>
            <th>Solicitado</th>
            <th>Aprobado</th>
            <th>Estatus</th>
            <th>Seguimiento</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="
              let solicitud of solicitudesUsuario
                | paginate
                  : {
                      id: 'solicitudesUsuario',
                      itemsPerPage: pageSize,
                      currentPage: currentPageSolicitudes,
                      totalItems: solicitudesUsuario.length
                    }
            "
          >
            <td><span class="table-page__text">{{ solicitud.fechaTrabajo | date : "dd/MM/yyyy" }}</span></td>
            <td>
              <div class="table-page__cell-stack">
                <span class="table-page__text">{{ solicitud.nombreProyecto || "Proyecto no identificado" }}</span>
                <span class="table-page__subtext">{{ solicitud.nombreTarea || "Sin tarea ligada" }}</span>
              </div>
            </td>
            <td><span class="table-page__text">{{ solicitud.minutosSolicitados }} min</span></td>
            <td><span class="table-page__text">{{ solicitud.minutosAprobados ?? 0 }} min</span></td>
            <td>
              <span
                class="table-page__status-badge"
                [ngClass]="{
                  'is-pending': solicitud.estatus === 'PENDIENTE',
                  'is-active': solicitud.estatus === 'APROBADO',
                  'is-danger': solicitud.estatus === 'RECHAZADO'
                }"
              >
                {{ solicitud.estatus }}
              </span>
            </td>
            <td>
              <div class="table-page__cell-stack">
                <span class="table-page__text">{{ solicitud.motivoEmpleado }}</span>
                <span class="table-page__subtext">{{ solicitud.comentarioLider || "Sin comentario del líder" }}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="table-page__footer" *ngIf="showSolicitudesPagination">
      <div class="table-page__meta">
        Mostrando {{ (currentPageSolicitudes - 1) * pageSize + 1 }} a
        {{ currentPageSolicitudes * pageSize > solicitudesUsuario.length ? solicitudesUsuario.length : currentPageSolicitudes * pageSize }}
        de {{ solicitudesUsuario.length }}
      </div>
      <div class="table-page__pager table-page__pager--ngx">
        <pagination-controls
          [id]="'solicitudesUsuario'"
          responsive="true"
          class="my-pagination"
          previousLabel="Anterior"
          nextLabel="Siguiente"
          [directionLinks]="true"
          [autoHide]="false"
          [maxSize]="5"
          (pageChange)="currentPageSolicitudes = $event"
        ></pagination-controls>
      </div>
    </div>
  </section>
  </div>
</div>

<ng-template #emptyPendientes>
  <div class="table-page__empty">
    <span class="material-icons">task_alt</span>
    <h3>No tienes solicitudes pendientes por resolver.</h3>
  </div>
</ng-template>

<ng-template #emptySolicitudes>
  <div class="table-page__empty">
    <span class="material-icons">schedule_send</span>
    <h3>Todavía no has enviado solicitudes de tiempo extra.</h3>
  </div>
</ng-template>
